// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: window.location.origin, // Base URL here
  authApiUrl: 'https://auth.surpass.cloud/', // PRODUCTION AUTH URL
  //authApiUrl: 'https://auth.surpass.foo/', //for local with docker
  //authApiUrl: 'https://localhost:8051/v1/', for local
  apiUrl: 'https://api.library.site/v1/', // PRODUCTION API URL
  //apiUrl: 'https://api.opac.foo/v1/', // your local API URL here
  //apiUrl: 'http://localhost:7051/v1/', // your local API URL here
  defaultTenant: 'pcs', // Fallback tenant when using bare 'localhost' (no subdomain)
  defaultConfiguration: '*', // Fallback configuration for bare localhost
  microsoftSso: {
    enabled: true,
    clientId: '3d5058e4-8277-494d-a2ca-7c4f18404469',
    authorityBaseUrl: 'https://login.microsoftonline.com',
    redirectUri: window.location.origin,
    scope: 'openid profile email' 
  },
  appInsights: {
        instrumentationKey: '1b2e7921-d183-46b5-8130-10c8b7dada0d'
    } 
    
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
